import React from "react";

import { getXOffset, getYOffset } from "./math";

const LabelLine = props => {
  const { cx, cy, midAngle, middleRadius, radius } = props;
  const xStart = cx + getXOffset(middleRadius + 19, midAngle);
  const yStart = cy + getYOffset(middleRadius + 19, midAngle);

  const offSetEnd = 3 * radius - middleRadius - 13;
  const xEnd = cx + getXOffset(offSetEnd, midAngle);
  const yEnd = cy + getYOffset(offSetEnd, midAngle);

  return (
    <polyline
      style={{
        fill: "#858181",
        stroke: "#858181",
        strokeWidth: "1px"
      }}
      points={`${xStart},${yStart} ${xEnd},${yEnd}`}
    />
  );
};

export default LabelLine;
